"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplitudeBrowserClient = exports.DEFAULT_AMPLITUDE_OPTIONS = void 0;
const amplitude = __importStar(require("@amplitude/analytics-browser"));
const plugin_session_replay_browser_1 = require("@amplitude/plugin-session-replay-browser");
const rula_common_plugin_1 = __importDefault(require("./plugins/rula-common-plugin"));
exports.DEFAULT_AMPLITUDE_OPTIONS = {
    serverUrl: "https://t.rula.com/2/httpapi",
    autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        // Deemed too noisy / less valuable to product for now
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
    },
};
class AmplitudeBrowserClient {
    apiKey;
    productCode;
    productArea;
    userId;
    userType;
    plugins;
    commonPlugin;
    client;
    constructor({ apiKey, productCode, productArea, userId, userType, plugins = [], options = exports.DEFAULT_AMPLITUDE_OPTIONS, }) {
        this.apiKey = apiKey;
        this.productCode = productCode;
        this.productArea = productArea;
        this.plugins = plugins;
        this.commonPlugin = new rula_common_plugin_1.default(productCode, productArea, userType);
        // In a server environment (NextJS), we won't want to call the third-party init,
        // as it depends on client-side dependencies and would throw errors
        if (typeof window === "undefined")
            return;
        amplitude.init(this.apiKey, undefined, options);
        this.setUser(userId, userType);
        // Add session replay feature. Sessions sampled at rate specified in Amplitude Settings UI
        const sessionReplayTracking = (0, plugin_session_replay_browser_1.sessionReplayPlugin)();
        this.plugins.push(this.commonPlugin);
        this.plugins.push(sessionReplayTracking);
        this.plugins.forEach((plugin) => {
            amplitude.add(plugin);
        });
    }
    setUser(userId, userType) {
        this.userId = userId;
        this.userType = userType;
        if (this.userId) {
            amplitude.setUserId(this.userId);
        }
        else {
            amplitude.setUserId(undefined);
        }
        const identifyEvent = new amplitude.Identify();
        if (this.userType !== undefined) {
            identifyEvent.set("user_type", this.userType);
        }
        amplitude.identify(identifyEvent);
    }
    track(trigger, eventProperties) {
        amplitude.track(this.getEventName(trigger), {
            ...eventProperties,
            trigger,
        });
    }
    resetPlugins() {
        this.plugins.forEach((plugin) => {
            if (plugin?.name) {
                const result = amplitude.remove(plugin.name);
                // There are situations where nested AmplitudeContextProvider result in TypeError: plugin is undefined
                // Tracking a better way to do this: https://github.com/amplitude/Amplitude-TypeScript/issues/916
                result.promise.catch((error) => {
                    console.warn("AmplitudeBrowserClient#resetPlugins - Warn: ", error);
                });
                amplitude.add(plugin);
            }
        });
    }
    getEventName(trigger) {
        return `${this.productCode}_${trigger}`;
    }
}
exports.AmplitudeBrowserClient = AmplitudeBrowserClient;
